/**
 * @deprecated Use custom Skeletons instead
 **/
export default function Loader() {
  return (
    <div className="loader border-brand dark:border-darkmodebrand">
      <span className="loader-inner bg-brand dark:bg-darkmodebrand" />
    </div>
  );
}
